"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Near = void 0;
var wallet_account_1 = require("@near-js/wallet-account");
Object.defineProperty(exports, "Near", { enumerable: true, get: function () { return wallet_account_1.Near; } });
